import { Box, Tooltip, Typography } from '@material-ui/core';

import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';

export const InfoTooltip = ({ textId, iconStyle }) => {
  return (
    <Tooltip
      placement={'top'}
      title={
        <Typography variant={'body2'}>
          <Text tId={textId} />
        </Typography>
      }
    >
      <Box display={'flex'}>
        <Icon style={iconStyle}>info</Icon>
      </Box>
    </Tooltip>
  );
};
